import React, { useEffect, useState } from 'react'
import GetMovie from '../../Services/Queries/GetMovie'
import GetMovieListDetailsService from '../../Services/Queries/GetMovieListDetalisService'
import GetMovieListServiceWithId from '../../Services/Queries/GetMovieListServiceWithId'
import ListHeaderLevelTaggedPersonsInMovieList from '../../Services/Queries/ListHeaderLevelTaggedPersonsInMovieList'
import Createlist from './Createlist'
import './list.css'
import LoadingSpinner from '../Movie/Loading'

export default function EditList() {
  const [listData, setListData] = useState()
  const [listDetails, setListDetails] = useState()
  const [MovieCatageory, setMovieCatageory] = useState('')
  const [MOvieListId, setMOvieListId] = useState()
  const [listID, setListId] = useState('')
  const [initialHeaderPersons, setInitalHeaderPersons] = useState([])
  const [editmovieListStatus, seteditmovieListStatus] = useState('draft')
  const [loadSpinner, setLoadSpinner] = useState(false)

  const getData = async () => {
    try {
      setLoadSpinner(true)
      const urlSplit = (window.location.href.split('?')[1] || '').replace('$', '#')
      setMOvieListId(decodeURIComponent(urlSplit))

      const input = { movieListID: decodeURIComponent(urlSplit) }
      const [listDetails, listDataTemp] = await Promise.all([
        GetMovieListServiceWithId(input),
        GetMovieListDetailsService(input),
      ])

      setMovieCatageory(listDetails.movieListCategory)
      seteditmovieListStatus(listDetails.movieListStatus)

      const headerLevelPersons = await ListHeaderLevelTaggedPersonsInMovieList({
        ...input,
        limit: 100,
      })

      setInitalHeaderPersons(headerLevelPersons.items)

      const allMoviePersonsInsideObject = await Promise.all(
        listDataTemp.items.map(async item => {
          item.label = listDetails.movieListCategory === 'Movie' ? item.title_En : item.name_En
          item.about_En = item.description
          item.listItemDescription = item.listItemDescription_En
          try {
            if (listDetails.movieListCategory === 'Movie') {
          const input = { movieID: item.PK }
          const movieOrPersonDataResponse = await GetMovie(input)

          let allPersons = []
          if (listDetails.movieListCategory === 'Movie' && movieOrPersonDataResponse.Crew) {
            allPersons = [...allPersons, ...movieOrPersonDataResponse.Crew]
          }

          if (movieOrPersonDataResponse.Cast) {
            allPersons = [...allPersons, ...movieOrPersonDataResponse.Cast]
          }

          item.taggedPersons = allPersons.filter(
            (obj, index) => index === allPersons.findIndex(o => obj.personID === o.personID),
          )

          return item
            }

              return item
        } catch (error) {
          console.error(error, 'error in get movie service')
          return item
        }
        }),
      )

      setListData(allMoviePersonsInsideObject)
      setListDetails({
        description_en: listDetails.description_En,
        description_te: listDetails.description_Te,
        title_en: listDetails.title_En,
        title_te: listDetails.title_Te,
        movieListImage: listDetails.movieListImage,
      })

      setListId(listDetails.SK)
      setLoadSpinner(false)
    } catch {
      setLoadSpinner(false)
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && !listData) {
        getData()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    if (!listData) {
      getData()
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [listData])
  return (
    <div>
      {loadSpinner && <LoadingSpinner />}
      <Createlist
        editMode={'edit'}
        editListData={listData}
        listDetails={listDetails}
        editMovieCatogary={MovieCatageory}
        MOvieListId={MOvieListId}
        listID={listID}
        initialHeaderPersons={initialHeaderPersons}
        editmovieListStatus={editmovieListStatus}
      />
    </div>
  )
}
